import React, { useEffect, useCallback } from "react";
import { useParams, useHistory } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import jwtDecode from 'jwt-decode';
import { useMutation, } from 'react-query';
import { Spinner } from 'reactstrap'

import Logo from '../images/logo/owl-logo.svg';
import { useAuthDispatch } from '../context/auth';

import useQueryParams from '../hooks/useQuery';
import { respondChallenge } from '../api/actions/auth'
import { fetcher } from '../api/client'


function AccountRedirect() {
    const { t } = useTranslation('common')
    // const { token } = useParams();
    const history = useHistory();
    const setAuth = useAuthDispatch();
    const queryParams = useQueryParams()
    const token = queryParams.get('token');
    const username = queryParams.get('username');
    const publicTemplateName = queryParams.get('publicTemplateName');
  
    const { mutate: mutateRespondChallenge } = useMutation((payload) => fetcher(respondChallenge(payload)),  {
        onSuccess: (result) => {
            const authResult = result.data.AuthenticationResult
            const idToken = jwtDecode(authResult.IdToken);
            setAuth({
                accessToken: authResult.AccessToken,
                refreshToken: authResult.RefreshToken,
                idToken: authResult.IdToken,
                expiresIn: authResult.ExpiresIn,
                expiresAt: Date.now() + (Number(authResult.ExpiresIn) * 1000),
                user: {
                    _id: idToken.profile,
                    givenName: idToken.given_name,
                    familyName: idToken.family_name,
                    name: idToken.name,
                    email: idToken.email,
                    verified: idToken.email_verified,
                    cognitoId: idToken.sub,
                //     organization: idToken['custom:organization']
                }
            })
            if (publicTemplateName) {
                history.push(`/templates/catalog?search=${publicTemplateName}&searchExact=true`)
            } else {
                history.push('/')
            }
            
        },
        onError: () => {
            setAuth({})
            history.push('/login')
        }
    })

    useEffect(() => {
        mutateRespondChallenge({ type: 'REDIRECT_CHALLENGE', session: token, username })
    }, [token, username, mutateRespondChallenge])

    return (
        <section id="signup" className="vh-100 d-flex">
            <div className="container align-self-center">
            <div className="card account-success align-self-center mx-auto w-50">
                <div className="card-body text-center p-lg-5 p-3 d-flex flex-column align-items-center">
                    <img src={Logo} className="img-fluid w-25 mb-3" alt="Trato Logo" />
                    <Spinner />
                    <small className="text-muted">{t('actions.redirecting')}</small>
                </div>
            </div>
            </div>
        </section>
    );
}

export default AccountRedirect;